import { render, staticRenderFns } from "./Landing2.vue?vue&type=template&id=a00b5344&scoped=true"
import script from "./Landing2.vue?vue&type=script&lang=js"
export * from "./Landing2.vue?vue&type=script&lang=js"
import style0 from "./Landing2.vue?vue&type=style&index=0&id=a00b5344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00b5344",
  null
  
)

export default component.exports